/**
 * Profile-details action flags. Only an explicit `true` shows the action.
 * Missing, null, or any other value hides it.
 */
export function isAdhaProfileActionEnabled(value: unknown): boolean {
  return value === true;
}
